import React, { useEffect, useState } from "react";
import { DatePicker, LocalizationProvider, TimePicker, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { s360ConfigService } from "../../../Services/S360Config";
import "./NCXComponents.styles.css";
import dayjs from "dayjs";
import { Button } from "@mui/material";

function NCXCalander (props) {
    const { text, subType, validation, sendMessageToPreview, id, disabled } = props;
    const { startRange, endRange } = validation;
    const [dateRead, setDateRead] = useState(null);
    const [disabledCal, disable] = useState(disabled);

    function apiFormatDate(value) {
        switch (subType) {
            case "date with time": {
                let year = value.getFullYear();
                let month = String(value.getMonth() + 1).padStart(2, '0');
                let day = String(value.getDate()).padStart(2, '0');
                let hours = String(value.getHours()).padStart(2, '0');
                let minutes = String(value.getMinutes()).padStart(2, '0');
                let seconds = String(value.getSeconds()).padStart(2, '0');
    
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };
            case "time": return value.toTimeString().split(' ')[0];
            case "date":
            default: {
                let year = value.getFullYear();
                let month = String(value.getMonth() + 1).padStart(2, '0');
                let day = String(value.getDate()).padStart(2, '0');

                return `${year}-${month}-${day}`;
            };
        }
    }

    function uiFormattedDate(value) {
        const now = new Date();
        const format1 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/; // year-month-day hours:minutes:seconds
        const format2 = /^\d{4}-\d{2}-\d{2}$/; // year-month-day
        const format3 = /^\d{2}:\d{2}:\d{2}$/; // hours:minutes:seconds
    
        let year, month, day, hours, minutes, seconds;
    
        if (format1.test(value)) {
            [year, month, day, hours, minutes, seconds] = value.split(/[- :]/);
        } else if (format2.test(value)) {
            [year, month, day] = value.split("-");
            hours = now.getHours();
            minutes = now.getMinutes();
            seconds = now.getSeconds();
        } else if (format3.test(value)) {
            [hours, minutes, seconds] = value.split(":");
            year = now.getFullYear();
            month = now.getMonth() + 1; // Months are zero-based in JavaScript
            day = now.getDate();
        } else {
            return new Date();
        }
    
        // Convert to integers
        year = parseInt(year);
        month = parseInt(month) - 1; // Months are zero-based in JavaScript
        day = parseInt(day);
        hours = parseInt(hours);
        minutes = parseInt(minutes);
        seconds = parseInt(seconds);
    
        return new Date(year, month, day, hours, minutes, seconds);
    }

    function handleDateChange(newDate) {
        setDateRead(apiFormatDate(new Date(newDate)));
    }

    function handleDateSubmit() {
        if (dateRead) {
            sendMessageToPreview(dateRead, null);
            disable(true);
        }
    }

    const primaryFontColorSelectorFromConfig = s360ConfigService.config?.configDetails?.primaryFontColor ?? "#000";
    const primaryColorSelectorFromConfig = s360ConfigService.config?.configDetails?.primaryColor ?? "#fff";

    const getThemedSlotProps = () => {
        return {
            tabs: {
                sx: {
                    "& .MuiTab-textColorPrimary.Mui-selected": {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`,
                    },
                    "& .MuiTabs-indicator": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    }
                }
            },
            previousIconButton: {
                sx: {
                    "&:disabled": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    }
                }
            },
            nextIconButton: {
                sx: {
                    "&:disabled": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    }
                },
            },
            actionBar: {
                sx: {
                    "& .MuiButton-root": {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`,
                        border: `1px solid ${primaryFontColorSelectorFromConfig} !important`,
                        ":hover": {
                            backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                            color: `${primaryColorSelectorFromConfig} !important`,
                            border: `1px solid ${primaryFontColorSelectorFromConfig} !important`,
                        }
                    }
                }
            },
            mobilePaper: {
                sx: {
                    '& .MuiClock-pin': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiClockPointer-root': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiClockPointer-thumb': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        borderColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiClockPointer-thumb.Mui-selected': {
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`,
                        borderColor: `${primaryColorSelectorFromConfig} !important`,
                        color: `${primaryFontColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersDay-root': {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersDay-root.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton': {
                        color: `${primaryFontColorSelectorFromConfig} !important` ,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    "& .MuiClockNumber-root.Mui-selected": {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    "& .MuiClockNumber-root": {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        // backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    }
                }
            },
            desktopPaper: {
                sx: {
                    '& .MuiPickersDay-root': {
                        color: `${primaryFontColorSelectorFromConfig} !important`,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersDay-root.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton': {
                        color: `${primaryFontColorSelectorFromConfig} !important` ,
                        backgroundColor: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiPickersYear-yearButton.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                    '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
                        backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                        color: `${primaryColorSelectorFromConfig} !important`
                    },
                }
            }
        }
    }

    function switchPicker(subType) {
        switch(subType) {
            case "date with time": return <MobileDateTimePicker 
                    minDateTime={dayjs(uiFormattedDate(startRange))}
                    maxDateTime={dayjs(uiFormattedDate(endRange))}
                    onChange={handleDateChange}
                    label={text}
                    // onAccept={handleDateSubmit}
                    disabled={disabledCal}
                    slotProps={getThemedSlotProps()}
                    className="dateTimeGenerics"
                    key={`${id}-calendarswitchpickerdatewithtime`}
                />;
            case "time": return <TimePicker 
                    minTime={dayjs(uiFormattedDate(startRange))}
                    maxTime={dayjs(uiFormattedDate(endRange))}
                    onChange={handleDateChange}
                    label={text}
                    // onAccept={handleDateSubmit}
                    disabled={disabledCal}
                    slotProps={{
                        ...getThemedSlotProps(),
                        desktopPaper: {
                            sx: {
                                '& .MuiMultiSectionDigitalClockSection-item': {
                                    color: `${primaryFontColorSelectorFromConfig} !important`,
                                    backgroundColor: `${primaryColorSelectorFromConfig} !important`
                                },
                                '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
                                    backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                                    color: `${primaryColorSelectorFromConfig} !important`
                                },
                            }
                        }
                    }}
                    key={`${id}-calendarswitcherpickertime`}
                />;
            default: return <DatePicker
                    minDate={dayjs(uiFormattedDate(startRange))}
                    maxDate={dayjs(uiFormattedDate(endRange))}
                    onChange={handleDateChange}
                    label={text}
                    // onAccept={handleDateSubmit}
                    disabled={disabledCal}
                    slotProps={{
                        ...getThemedSlotProps(),
                        day: {
                            sx: {
                                '&.MuiPickersDay-root': {
                                    color: `${primaryFontColorSelectorFromConfig} !important`,
                                    backgroundColor: `${primaryColorSelectorFromConfig} !important`
                                },
                                '&.MuiPickersDay-root.Mui-selected': {
                                    backgroundColor: `${primaryFontColorSelectorFromConfig} !important`,
                                    color: `${primaryColorSelectorFromConfig} !important`
                                },
                            }
                        },
                        desktopPaper: {
                            sx: {
                                '& .MuiPickersYear-yearButton': {
                                    color: `${primaryFontColorSelectorFromConfig} !important` ,
                                    backgroundColor: `${primaryColorSelectorFromConfig} !important`
                                },
                                '& .MuiPickersYear-yearButton.Mui-selected': {
                                    backgroundColor: `${primaryFontColorSelectorFromConfig} !important` ,
                                    color: `${primaryColorSelectorFromConfig} !important`
                                },
                                '&.MuiPaper-elevation8': {
                                    width: '320px !important'
                                }
                            }
                        },
                    }}
                    key={`${id}-calendarswitchpickerdate`}
                />;
        }
    }

    return (
        <div className="calendarContainer" key={`${id}-calendarcontainer`}>
            <LocalizationProvider dateAdapter={AdapterDayjs} key={`${id}-calendarlocalizationprovider`}>
                {switchPicker(subType)}
            </LocalizationProvider>
            <Button
                className="buttonPlain"
                variant="contained"
                onClick={handleDateSubmit}
                disabled={disabledCal}
                sx={{
                    backgroundColor: `${s360ConfigService.config?.configDetails?.primaryColor ?? '#fff'} !important`, // Background color should be white or transparent
                    color: `${s360ConfigService.config?.configDetails?.primaryFontColor ?? '#000'} !important`,
                    width: '100px !important',
                    borderRadius: props.config?.customDesign?.button?.borderRadius ?? "30px !important",
                    border: "2px solid #d9d9d9 !important", // Light grey border
                    margin: "10px", // Margin to create space between buttons
                    padding: "10px",
                    fontSize: "12px", // Adjust text size
                    fontFamily: "'Lato', sans-serif",
                    textAlign: "center",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    transition: "background-color 0.3s ease-in-out, color 0.3s",
                    boxShadow: 'none',
                    "&:hover": {
                        backgroundColor: "#f2f2f2", // Slight change on hover
                        border: "2px solid #b3b3b3 !important",
                        boxShadow: 'none',
                    },
                    "&:disabled": {
                        backgroundColor: "#fff !important",
                        color: "#b3b3b3", // Change text color when disabled
                        borderColor: "#e0e0e0", // Light grey border when disabled
                        opacity: "0.2 !important", // Reduce opacity when disabled
                    },
                }}
                key={`${id}-calendarbuttonsubmit`}
            >Schedule
            </Button>
        </div>
    );
}

export default NCXCalander;